@if (!(checklistService.loading$ | async)) {
  <div mat-dialog-title>
    <div class="wrapper">
      <div>
        <h2>
          @if ((checklistService.consentRequest$ | async)?.project) {
            <contact-link
              color="white"
              [textDecoration]="false"
          [subject]="
            $safeNavigationMigration((checklistService.consentRequest$ | async)?.project)
          "></contact-link>
          }
        </h2>
        <h3>
          @if (retrieveSponsor()) {
            <contact-link
              color="white"
              [textDecoration]="false"
          [subject]="
           retrieveSponsor()
          "></contact-link>
          }
        </h3>
      </div>
      <div>
        <button mat-icon-button (click)="this.dialogRef.close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
}
@if (!(checklistService.loading$ | async)) {
  <div mat-dialog-content>
    <div>
      <span class="request-type label"
        >{{
        (checklistService.consentRequest$ | async)?.consentRequestType
        ?.request_type ?? ""
        }}:</span
        ><span class="request-status">{{
        (checklistService.consentRequest$ | async)?.consentStatus?.status ??
        "\u2014"
      }}</span>
    </div>
    <div>
      <span class="requested label">Date Received:</span
        ><span class="received-date">{{
        ($safeNavigationMigration((checklistService.consentRequest$ | async)?.received_date)
        | date: "MM/dd/yyyy") ?? "\u2014"
      }}</span>
    </div>
    <div>
      <p class="details">
        {{ (checklistService.consentRequest$ | async)?.details }}
      </p>
    </div>
    <div class="urgency-wrapper">
      <span
        class="is-urgent"
      [class.urgent]="
        (checklistService.consentRequest$ | async)?.is_urgent_flag
      ">
        <mat-icon inline>{{
          (checklistService.consentRequest$ | async)?.is_urgent_flag
          ? "flag"
          : "outlined_flag"
        }}</mat-icon>
      </span>
      <span class="due label">Due:</span>
      <span class="timing-date">{{
        ($safeNavigationMigration((checklistService.consentRequest$ | async)?.timing_date)
        | date: "MM/dd/yyyy") ?? "\u2014"
      }}</span>
    </div>
    <div>
      <p class="urgency-note">
        {{ (checklistService.consentRequest$ | async)?.urgency_note }}
      </p>
    </div>
    <div class="table-label">
      <h3>Tasks</h3>
      @if (checklistService.permission$ | async | permission: '_create') {
        <button
          class="add-button"
          (click)="openCreateDialog()"
          >
          <mat-icon inline>add_box</mat-icon>
        </button>
      }
    </div>
    <tasks-table
      [isUrgent]="!!(checklistService.consentRequest$ | async)?.is_urgent_flag"
    [consent_request_id]="data.consentRequestId"></tasks-table>
  </div>
}
@if (!!(checklistService.loading$ | async)) {
  <div
    mat-dialog-content
    class="loading-content">
    <mat-spinner></mat-spinner>
  </div>
}
